import script from "./ConfigTechniciansSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigTechniciansSection.vue?vue&type=script&setup=true&lang=js"

import "./ConfigTechniciansSection.vue?vue&type=style&index=0&id=6eac6750&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eac6750"]])

export default __exports__